// Module
var code = "<button class=\"table-header__toggle-filters\" ng-class=\"{&#39;table-header__toggle-filters--active&#39;: open}\" ng-click=\"onClick()\" type=\"button\"><div class=\"table-header__toggle-filters-label\">Filter</div></button>\n";
// Exports
module.exports = code;